import { render } from "./DeviceMessageDetails.vue?vue&type=template&id=51559137"
import script from "./DeviceMessageDetails.vue?vue&type=script&lang=js"
export * from "./DeviceMessageDetails.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__